import {
  SSRMRequestsApi,
  type SsrmAccessRequestResult,
  type SsrmCatalogItemDetail,
  type SsrmCatalogResponse,
  type SsrmResourceGroup,
  type SsrmSubmitRequest,
  type SsrmSubmitResult,
  type SsrmSubscription,
} from 'cmp-client-api';
import type { RequestsServiceInterface } from './types/requests-service.interface';

export class RequestsService implements RequestsServiceInterface {
  private readonly service: SSRMRequestsApi;

  public constructor(service: SSRMRequestsApi) {
    this.service = service;
  }

  public getCatalog(): Promise<SsrmCatalogResponse> {
    return this.service.getSsrmCatalog().then(({ data }) => data);
  }

  public getCatalogItem(formKey: string, signal?: AbortSignal): Promise<SsrmCatalogItemDetail> {
    return this.service
      .getSsrmCatalogItem(formKey, undefined, undefined, { signal })
      .then(({ data }) => data);
  }

  public getSubscriptions(tenantId: string, signal?: AbortSignal): Promise<SsrmSubscription[]> {
    if (!tenantId) return Promise.resolve([]);

    return this.service
      .getSsrmTenantSubscriptions(tenantId, undefined, undefined, { signal })
      .then(({ data }) => data.items);
  }

  public getResourceGroups(
    subscriptionId: string,
    signal?: AbortSignal
  ): Promise<SsrmResourceGroup[]> {
    if (!subscriptionId) return Promise.resolve([]);

    return this.service
      .getSsrmSubscriptionResourceGroups(subscriptionId, undefined, { signal })
      .then(({ data }) => data.items);
  }

  public submitForm(formKey: string, request: SsrmSubmitRequest): Promise<SsrmSubmitResult> {
    return this.service.submitSsrmForm(formKey, request).then(({ data }) => data);
  }

  public requestAccess(formKey: string): Promise<SsrmAccessRequestResult> {
    return this.service.requestSsrmFormAccess(formKey).then(({ data }) => data);
  }
}
